import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homesix-contact',
  templateUrl: './homesix-contact.component.html',
  styleUrls: ['./homesix-contact.component.scss']
})
export class HomesixContactComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
